<template>
    <gofix-card :title="titleTable" class="finance-budget-card-table" classHeader="pl-19" classContent="mb-0" fullContent>
        <!-- gofix-default-table -->
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @delete-items="deleteItems" 
            @new-item="newItem"
            @export="exportItems"
            ref="gofixTable">
            <template slot="gofix_table:edit" slot-scope="row">
                <button 
                    v-if="HeaderItem.status == 'Draft' || (HeaderItem.status == 'Approved' && row.item.entry_type === 'Revision' && row.item.month_year[0] && row.item.month_year[0].status == 'rev-draft')"
                    type="button" 
                    class="icon-button position-relative"
                    @click="handleShowModalEdit(row.item)">
                    <img width="20" src="img/iconPencil.png" alt="" />
                </button>
            </template>
            <template 
                slot="gofix_table:actions" slot-scope="data" 
                v-if="
                    (HeaderItem.status == 'Approved' && data.item.entry_type === 'Planned') ||
                    (HeaderItem.status == 'Approved' && data.item.entry_type === 'Revision' && data.item.month_year[0]  && data.item.month_year[0].status == 'rev')
                ">
                <b-form-checkbox disabled></b-form-checkbox>
            </template>
            <template slot="gofix_table:fm_code" slot-scope="row">
                <div class="d-flex">
                    <span class="mr-14 col px-0">{{ row.item.fm_code }}</span>
                    <span class="col px-0" style="text-transform: capitalize;" v-if="row.item.entry_type == 'Revision'">
                        {{ row.item.month_year[0] && row.item.month_year[0].status ? row.item.month_year[0].status : ''}}
                    </span>
                </div>
            </template>
            <template slot="gofix_table:total_budget" slot-scope="row">
                {{ row.item.total_allocated | formatMoney }}
            </template>
            <template :slot="`gofix_table:${item.label}`" v-for="(item, index) in dynamicFields" slot-scope="row">
                <span :key="index" v-if="row.item.month_year[index]">
                    {{ row.item.month_year[index].allocated_amount | formatMoney }}
                </span>
            </template>
            <template slot="gofix_table:bottom-row" slot-scope="row">
                <td class="text-nowrap" :key="i" v-for="(field, i) in row.data.fields">
                    <div class="total-header" v-if="field.key === 'fm_code'">
                        <p class="mb-0">Total Budget {{ titleTable }}</p>
                    </div>
                    <div class="total-value d-flex align-items-end flex-column" v-if="field.key === 'total_budget'">
                        <p v-if="category == 'Revenue'" class="text-right mb-0">{{ HeaderItem.total_budget_revenue | formatMoney }}</p>
                        <p v-if="category == 'Expenses'" class="text-right mb-0">{{ HeaderItem.total_budget_expenses | formatMoney }}</p>
                    </div>
                    <div class="total-value d-flex align-items-end flex-column" v-if="!['actions', 'total_budget', 'fm_code', 'contract_name', 'description', 'gl_code', 'root_path_properties', 'name_service', 'work_type', 'financial_year_start', 'financial_year_end', 'total_budget_revenue', 'total_budget_expenses', 'edit'].includes(field.key)">
                        <p class="text-right mb-0">{{ findSumFollowLabel(field.key) | formatMoney }}</p>
                    </div>
                </td>
            </template>
        </gofix-table>
        <ModalBudgetItem 
            :title="modal.title" 
            :titleTotal="titleTable"
            :contract_id="HeaderItem.client_contract_id"
            :item="modal.itemSelected"
            :isNew="modal.isNew"
            :glAccountGroup="category"
            @storeSuccess="reloadItems"
            v-model="modal.open"/>
    </gofix-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    const ModalBudgetItem = () => import('./modal-budget-item.vue')
    import moment from 'moment';
    const accounting = require('accounting');
    const fieldDefault = [
        {
            key: 'actions',
            label: '',
            thStyle: "width:50px",
            isActive: 1,
            isFilter: false,
            sorting: false
        },
        {
            key: 'fm_code',
            label: 'FM Code',
            thStyle: "width:170px",
            isActive: 1,
            isFilter: true,
            sorting: true
        },
        {
            key: 'description',
            label: 'Description',
            thStyle: "width:170px",
            isActive: 1,
            isFilter: true,
            sorting: true
        },
        {
            key: 'gl_code',
            label: 'GL Code',
            isActive: 1,
            thStyle: "width:110px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'root_path_properties',
            label: 'Property',
            isActive: 1,
            thStyle: "width:200px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'name_service',
            label: 'Service Category',
            isActive: 1,
            thStyle: "width:150px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'work_type',
            label: 'Work Type',
            isActive: 1,
            thStyle: "width:110px",
            isFilter: true,
            sorting: true
        }
    ];

    export default {
        name: 'budget-entries',
        components: {
            ModalBudgetItem
        },
        props: {
            titleTable: {
                type: String,
                default: ''
            },
            category: {
                type: String,
                default: ''
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['budget_entries']));
            return {
                modal: {
                    open: false,
                    title: '',
                    isNew: false,
                    itemSelected: {}
                },
                totalSumDate: [],
                tableItems: [],
                tableConfig:{
                    name: 'budget-entries',
                    controls:{
                        tableImport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    fields: JSON.parse(JSON.stringify(fieldDefault))
                },
                dynamicFields: []
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            })
        },
        watch: {
            HeaderItem: function(val, old) {
                if(val) {
                    this.$refs.gofixTable.reloadTableItems();
                    this.getColumnSettings();
                }
            }
        },
        methods: {
            getColumnSettings() {
                if(this.HeaderItem && this.HeaderItem.financial_year_start) {
                    var dateStart = moment(this.HeaderItem.financial_year_start);
                    var dateEnd = moment(this.HeaderItem.financial_year_start).add(11, 'M');
                    var timeValues = [];
                    let fields = [];
                    while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                        fields.push({
                            key: dateStart.format('YYYY-MM'),
                            label: dateStart.format('MMM, YYYY'),
                            thStyle: "width:130px",
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            width: 200,
                            isActive: 1,
                            isFilter: false,
                            sorting: false
                        })
                        timeValues.push({
                            label: dateStart.format('YYYY-MM'),
                            value: ''
                        });
                        dateStart.add(1,'month');
                    }
                    this.dynamicFields = timeValues;
                    fields.push({
                        key: 'total_budget',
                        label: 'Total Budget',
                        isActive: 1,
                        thStyle: "width:150px",
                        thClass: 'text-right',
                        tdClass: 'text-right',
                        isFilter: false,
                        sorting: false
                    })
                    fields.push({
                        key: 'edit',
                        label: '',
                        isActive: 1,
                        thStyle: "width:50px",
                        thClass: 'text-right',
                        tdClass: 'text-right',
                        isFilter: false,
                        sorting: false
                    })
                    this.tableConfig.fields = [...fieldDefault, ...fields];
                    this.$refs.gofixTable.updateColumnSettings(this.tableConfig.fields);
                }
            },
            findSumFollowLabel(label) {
                if(!this.totalSumDate.length) return null;
                let arrTmp = this.totalSumDate.filter(item => moment(item.calendar_month).format('YYYY-MM') == label)
                if(arrTmp.length) {
                    return arrTmp[0].sum_calendar_month;
                }
                return null;
            },
            calculateTotalBudget(month_year) {
                if(!month_year.length) return 0;
                let total = 0;
                month_year.map(item => {
                    total += item.allocated_amount;
                })
                return total;
            },
            reloadItems(is_reload_list = true) {
                this.$store.dispatch("BudgetAllocationController/getHeaderItem", this.$route.params.id)
                .then(response => { })
                .catch(async err => {
                    await this.$router.push(`/v2/budget`);
                    await this.$alertNotification("Id does not exist", "danger");
                    reject();
                })

                if(is_reload_list)
                    this.$refs.gofixTable.reloadTableItems();
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if (!this.$route.params.hasOwnProperty('id') || this.$route.params.id == "0" || isNaN(this.$route.params.id)) {
                    resolve({
                        items: [],
                        total: 0
                    })
                    return
                }
                tableRequest.filter.budget_category.value = this.category;
                tableRequest.filter.budget_header_id.value = this.$route.params.id;
                await this.$store.dispatch("BudgetAllocationController/getBudgetEntries", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.totalSumDate = response.sum_date
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback) {
                const { ids, filter, resolve, reject } = await callback();
                await this.$store
                    .dispatch("BudgetAllocationController/deleteBudgetEntries", JSON.stringify(ids))
                    .then(response => {
                        this.reloadItems(false);
                        resolve(this.$notificationV2('deleting', 'budget_entries'))
                    })
                    .catch(err => {
                        reject();
                    });
            },
            async newItem(callback) {
                this.modal.isNew = true;
                this.modal.itemSelected = {
                    financial_year_start: this.HeaderItem.financial_year_start
                },
                this.modal.title = `Add ${this.titleTable}`;
                if(this.HeaderItem.status == 'Approved')
                    this.modal.title = `Adjustments ${this.titleTable}`;
                this.modal.open = true;
            },
            handleShowModalEdit(item) {
                this.modal.isNew = false;
                this.modal.title = `Edit ${this.titleTable}`;
                let objeClone = JSON.parse(JSON.stringify(item));
                objeClone.status = objeClone.month_year[0] && objeClone.month_year[0].status ? objeClone.month_year[0].status : null;
                objeClone.budgets = objeClone.month_year.map(item => {
                    let val = {
                        key: item.calendar_month,
                        label: moment(item.calendar_month).format('MMM, YYYY'),
                        value: accounting.formatMoney(item.allocated_amount)
                    }
                    return val;
                })
                this.modal.itemSelected = objeClone;
                this.modal.open = true;
            },
            exportItems(tableRequest) {
                let request = JSON.parse(JSON.stringify(tableRequest));
                request.filter = JSON.stringify(request.filter);
                this.$store.dispatch( 'BudgetAllocationController/exportBudgetEntries', tableRequest)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'BudgetEntries.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
        }
    }
</script>
